<template>
  <nav class="breadcrumbs">
    <template v-for="(item,index) in breadcrumbs">
      <nuxt-link :data-index="index" :to="linkFor(item)"> {{
          item.title
        }}
      </nuxt-link>
      <img v-if="index < breadcrumbs.length-1" src="/static/img/icons/bread-arrow.svg">
    </template>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: []
    }
  },
  methods: {
    linkFor(item) {
      if (item.url === null || item.url === undefined) {
        return '#'
      }

      return item.url === '' ? '/' : '/' + item.url
    }
  }
}
</script>

<style scoped lang="scss">
.breadcrumbs {
  gap: 4px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

a {
  font-size: 12px;
  color: $dark-black;
  text-decoration: underline;

  @include smd {
    font-size: 10px;
  }
}

img {
  @include smd {
    width: 10px;
  }
}
</style>
